module.exports = __webpack_public_path__ + "static/Benqi-fe2b1d613c5cca605a6572edbe3ff144.png";